import { APP_BASE_HREF } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { LocalizationService } from '../../../Core/Localization/services/localization.service';


@Injectable()
export class SocialChartTooltipService {

    constructor(
        public localizationService: LocalizationService,
        @Inject(APP_BASE_HREF) public appBaseHref: string
    ) {}

    getTooltipHTML(
        chartClass: string,
        label: string,
        value: string,
        valueName?: string,
        icon?: string,
        doLink: boolean = true,
        /** Narrow it where the chart is small enough that the default leaves the card mostly empty */
        minWidth: string = '250px',
    ): string {
        const html = `
            <div
                style="margin: 10px; font-size: 0.875rem;"
            >
                <div
                   style="border-bottom: 1px solid #ced4da; padding-bottom: 5px; min-width: ${minWidth}; max-width: 320px; overflow-wrap: break-word;"
                >

                    <b style="font-weight: 600">${label}</b>
                </div>
                <div style="margin-top: 10px; display: flex; align-items: center">
                    ${icon ? this.getTooltipIcon(icon) : ''}
                    <p style="margin-right: ${doLink ? '20px' : '0'}">
                        ${valueName ? `<b style="font-weight: 600"> ${valueName}:</b>` : ''}
                        ${value}
                    </p>
                    ${doLink ? this.getTooltipLink(chartClass) : ''}
                </div>
            </div>
        `;
        return html;
    }

    getMultiSeriesSharedTooltipHTML(
        chartClass: string,
        value: string,
        valueName?: string,
        icon?: string,
        doLink: boolean = true,
    ): string {
        const html = `
            <div style="margin-top: 10px; display: flex; align-items: center">
                ${icon ? this.getTooltipIcon(icon) : ''}
                <p style="margin-right: 20px">
                    ${valueName ? `<b style="font-weight: 600"> ${valueName}:</b>` : ''}
                    ${value}
                </p>
                ${doLink ? this.getTooltipLink(chartClass) : ''}
            </div>
        `;
        return html;

    }

    private getTooltipLink(chartClass: string) {
        return `<div style="margin-left: auto; visibility: {hasDataForPeriod};">
            <a
                class="viewMentionLink ${chartClass}"
                href="{viewMentionUrl}"
                style="color: inherit;
                    text-decoration: underline;
                    font-size: 0.875rem;
                "
            >
            ${this.getLinkLabel()}
            </a>
        </div>`;
    }

    private getTooltipIcon(icon: string) {
        return `<i
                    class="${icon}"
                    style="display: flex;
                    color: {color};
                    margin-right: 10px"
                ></i>`;
    }

    private getLinkLabel(): string {
        return this.localizationService.transform('Social.intelligence.themeAnalytics.tooltip.actionLabel');
    }
}
